<div [ngClass]="getUsageClass()" class="video">
  <stxt-skeleton-loader *ngIf="shouldShowSkeleton()" [usage]="mediaUsage"></stxt-skeleton-loader>
  <video
    *ngIf="src && src.length > 0"
    [id]="videoId"
    [src]="src"
    [ngStyle]="{
      'border-radius': videoType === ECreatorVideoTypes.Preview ? '20px' : '0',
      opacity: loadingState.isRendered ? 1 : 0,
      transition: 'opacity 1.5s ease'
    }"
    [tabindex]="tabindex"
    [controls]="false"
    [muted]="muted"
    [loop]="loop"
    [preload]="preload"
    playsinline
    webkit-playsinline
    (loadstart)="onVideoStateChange($event)"
    (loadedmetadata)="onVideoStateChange($event)"
    (loadeddata)="onVideoStateChange($event)"
    (canplay)="onVideoStateChange($event)"
    (canplaythrough)="onVideoStateChange($event)"
    (error)="onVideoStateChange($event)"
    (ended)="onVideoStateChange($event)"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
    (click)="onVideoClick($event)"
    (keydown.enter)="onVideoClick($event)"
  ></video>

  <button
    *ngIf="controls && !isPlaying"
    (click)="togglePlayPause($event)"
    class="play-pause-button"
  >
    <stxt-svg-icon class="play_svg" [iconConfig]="playIcon"></stxt-svg-icon>
  </button>
  <button
    *ngIf="controls && isPlaying"
    (click)="togglePlayPause($event)"
    class="play-pause-button pause-button"
  >
    <stxt-svg-icon [iconConfig]="pauseIcon" class="play_svg"></stxt-svg-icon>
  </button>
</div>
